export default "__VITE_ASSET__CKG9MJ6q__"